import classNames from 'classnames';
import type { Ref } from 'react';

type RecordLike = Record<string, unknown>;

/**
 * Simplified mergeSlotProps (MUI-compatible) for the non-getSlotProps code path.
 */
export function mergeSlotProps<T extends RecordLike>(parameters: {
  additionalProps?: T;
  externalForwardedProps?: T;
  externalSlotProps?: T;
  className?: string;
}): { props: T; internalRef: Ref<unknown> | undefined } {
  const { additionalProps, externalForwardedProps, externalSlotProps, className } = parameters;

  const joinedClasses = classNames(
    additionalProps?.className as string | undefined,
    className,
    externalForwardedProps?.className as string | undefined,
    externalSlotProps?.className as string | undefined
  );

  const mergedStyle = {
    ...(additionalProps?.style as object | undefined),
    ...(externalForwardedProps?.style as object | undefined),
    ...(externalSlotProps?.style as object | undefined),
  };

  const props = {
    ...additionalProps,
    ...externalForwardedProps,
    ...externalSlotProps,
  } as T;

  if (joinedClasses) {
    (props as RecordLike).className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    (props as RecordLike).style = mergedStyle;
  }

  return { props, internalRef: undefined };
}

export default mergeSlotProps;
